import React from "react";

const DonationBtn = () => {
  return (
    <div className="center">
      <button className="btn">
        <a href="https://ko-fi.com/hugiholm">Kauptu fyrir mig kaffi</a>
      </button>
    </div>
  );
};

export default DonationBtn;
